import { Arrow, Content } from '@radix-ui/react-hover-card'
import styled from 'styled-components'

import type { Size, Width } from '../../../themes/types'
import { hoverAnimation } from '../../../utils/styles/animations.styles'

export const StyledContent = styled(Content)<{ $spacing: Size; $minWidth: Width }>`
  z-index: 1000;
  border-radius: ${props => props.theme.dimensions.borderRadius};
  padding: ${props => props.theme.spacings[props.$spacing]};
  min-width: ${props => props.$minWidth};
  background-color: ${props => props.theme.colors.white.base};

  ${hoverAnimation}
`

export const StyledArrow = styled(Arrow)`
  fill: ${props => props.theme.colors.white.base};
`
